/**
 * A stable handler for the common `onClick={e => e.stopPropagation()}`, which otherwise hands the
 * element a new function identity on every render.
 */
export const stopPropagation = (e: { stopPropagation: () => unknown }) => e.stopPropagation()
